import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import TableWrapper from '../../../../component/TableWrapper';
import { Icons } from '../../../../assets';
import NormalSelect from '../../../../component/NormalSelect';
import AdminPermission from '../../../../modalComponents/AdminPermission';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GetUserPermission from '../../../../component/GetUserPermission';

const AdminTableList = (props) => {
    const { searchInput } = props
    const ACTIVE = 'Active'
    const IN_ACTIVE = 'Inactive'
    const dropdownList = [
        { label: ACTIVE, value: true },
        { label: IN_ACTIVE, value: false },
    ]

    const [page, setPage] = useState(1);
    const [sortConfig, setSortConfig] = useState(null);
    const [showPopUp, setShowPopUp] = useState(false)
    const [selectedInfo, setSelectedInfo] = useState(null)
    const [userList, setUserList] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const viewPermission = GetUserPermission({ key: 'view' });
    const deletePermission = GetUserPermission({ key: 'delete' });
    const editPermission = GetUserPermission({ key: 'edit' });

    const userHeader = [
        { label: 'User Name', sortable: "name" },
        { label: 'Email', sortable: "email" },
        // { label: 'Mobile Number' },
        { label: 'Status' },
        { label: 'Actions' },
    ];

    useEffect(() => {
        getUserList()
    }, [page, sortConfig, searchInput])


    const getUserList = async () => {
        setisLoading(true)
        let url = `${Exported.Endpoints.getAdminList}`
        let paramsObj = {
            page: page,
            limit: 10,
        }

        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }
        if (sortConfig) {
            paramsObj['sort'] = sortConfig?.key
            paramsObj['sortOrder'] = sortConfig?.direction
        }

        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta
                }
                setUserList(obj)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        setisLoading(false)
    }

    const handleView = async (id) => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.getAdminList}/${id}`
        await request({
            url: url,
        }).then((res) => {
            if (res?.data?.status) {
                setShowPopUp(true)
                setSelectedInfo(res?.data?.data)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }

    const handleStatus = async (id, value) => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.getAdminList}/${id}`

        const requestData = {
            status: value,
        }
        await request({
            url: url,
            method: Exported.APIMethods.PUT,
            data: requestData
        }).then(async (res) => {
            if (res?.data?.status) {
                await getUserList()
                Toast({
                    type: 'success',
                    message: 'Status updated successfully'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }

    const handleDelete = async (id) => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.getAdminList}/${id}`
        const requestData = {
            id: id,
        }
        await request({
            url: url,
            method: Exported.APIMethods.DELETE,
            data: requestData
        }).then(async (res) => {
            if (res?.data?.status) {
                await getUserList()
                Toast({
                    type: 'success',
                    message: 'Record deleted successfully!...'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }

    const handleData = (keyValue, defaultValue, className = '') => {
        return (
            <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
        )
    };

    const handleClosePopUp = () => {
        setSelectedInfo(null)
        setShowPopUp(false)
    }

    const handleEdit = (id) => {
        navigate(`?type=edit?id=${id}`)
    }

    return (
        <>
            <div className={`eventWrapper`}>
                <div className={`mt-2 mb-5 ${classes.adminTableWrapper}`}>
                    <TableWrapper
                        headerDetails={userHeader}
                        pageMeta={userList?.pageMeta}
                        handlePageChange={setPage}
                        listLength={userList?.result || []}
                        isLoading={isLoading}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                    >
                        {userList?.result?.map((item, index) => {
                            const { name = '', email = '', status = false, id = '' } = item;
                            return (
                                <tr key={id}>
                                    {handleData(name, '-', 'text-center')}
                                    {handleData(email, '-', 'text-center')}
                                    {/* {handleData(mobileNumber, '-', 'text-center')} */}
                                    <td className=" px-3 mx-auto text-center w-[130px]">
                                        <div className=' '>
                                            <NormalSelect
                                                className={`w-[100%] p-0`}
                                                list={dropdownList}
                                                value={status ? ACTIVE : IN_ACTIVE}
                                                handleChange={(e) => e !== status ? handleStatus(id, e) : null}
                                                highLight
                                                highLightColor={
                                                    status ? "#01CB46" :
                                                        "#FC0000"
                                                }
                                                placeholder="Status"
                                            />
                                        </div>
                                    </td>
                                    <td className=" px-3 mx-auto text-center action-button">
                                        <div className='flex items-center justify-center'>
                                            <img src={Icons.eye} alt='View' className='cursor-pointer w-[20px] h-[20px]' onClick={() => handleView(item.id)} />
                                            {editPermission ?
                                                <img src={Icons.edit} alt='Edit' className='cursor-pointer w-[18px] h-[18px] mx-2' style={{ cursor: status ? 'pointer' : 'default', opacity: status ? '1' : '0.5' }} onClick={() => status ? handleEdit(item?.id) : null} />
                                                : null}
                                            {deletePermission ?
                                                <img src={Icons.delete} alt='Delete' className='cursor-pointer w-[20px] h-[20px]' style={{ cursor: status ? 'pointer' : 'default', opacity: status ? '1' : '0.5' }} onClick={() => status ? handleDelete(item?.id) : null} />
                                                : null}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                    </TableWrapper>
                </div>
            </div>
            {showPopUp ?
                <AdminPermission isOpen={showPopUp} closePopUp={handleClosePopUp} detailInfo={selectedInfo} />
                : null
            }
        </>
    )
}

export default AdminTableList